export default "__VITE_ASSET__Bcu36dzT__"